export enum DrawerSection {
  Files = 'files',
  Approvals = 'approvals',
}

export const DRAWER_SECTION_LABELS: Record<DrawerSection, string> = {
  [DrawerSection.Files]: 'Archivos',
  [DrawerSection.Approvals]: 'Aprobaciones',
};
